import { render, staticRenderFns } from "./Publikationen.vue?vue&type=template&id=400c98fe&scoped=true&"
import script from "./Publikationen.vue?vue&type=script&lang=js&"
export * from "./Publikationen.vue?vue&type=script&lang=js&"
import style0 from "./Publikationen.vue?vue&type=style&index=0&id=400c98fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400c98fe",
  null
  
)

export default component.exports